import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Box } from '@rebass/grid';
import ReactGA from 'react-ga';
import animate from 'app/helpers/animations/unlockForm';
import { isMobile } from 'app/helpers/utils';

import { Button, A, P } from 'app/ui_components/tags';

import { emailIsValid } from 'app/helpers/validators';
import { createLead, onInputChange } from 'app/redux/actions';

import RestaurantReportUnlockForm from 'app/components/RestaurantReportUnlockForm';

class UnlockForm extends React.Component {
  static propTypes = {
    usFoods: PropTypes.bool.isRequired,
    handleChange: PropTypes.func.isRequired,
    submit: PropTypes.func.isRequired,
    layout: PropTypes.object.isRequired,
    isBentobox: PropTypes.bool.isRequired,
    disabled: PropTypes.bool.isRequired,
    name: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    restaurantName: PropTypes.string,
    zipcode: PropTypes.string,
    phone: PropTypes.string,
    usfEmployeeName: PropTypes.string,
    usfEmployeeEmail: PropTypes.string,
    usfCustomerId: PropTypes.string,
    userType: PropTypes.string
  };

  componentDidMount() {
    ReactGA.pageview('Results Preview');
    window.fbq && window.fbq('track', 'PageView');
  }

  componentWillUnmount() {
    animate();
  }

  render() {
    const {
      layout,
      isBentobox,
      submit,
      disabled
    } = this.props;

    return (
      <div style={{ textAlign: 'center' }} id="unlockForm">
        {!isBentobox ? (
          <React.Fragment>
            <Box {...layout} my={40}>
              <P size={14} color="#4E4F57">
                Unlock your full report to receive a personalized action plan
                for your website now
              </P>
            </Box>
            <Box {...layout} px={200}>
              <RestaurantReportUnlockForm />
            </Box>
            <Box {...layout} px={200}>
              <Button onClick={submit} disabled={disabled} type="submit">
                Reveal All Details
              </Button>
            </Box>
            <Box width={[1 / 1, 3 / 4, 2 / 3]} mt={[0, 0, 40]} {...layout}>
              <P size={13}>
                By completing this form and submitting your information above,
                you are agreeing to our{' '}
                <A
                  href="https://getbento.com/privacy"
                  target="_blank"
                  size={13}
                  lineHeight={19}
                  style={{ marginTop: isMobile ? 0 : '10px' }}
                >
                  Privacy Policy
                </A>.
              </P>
            </Box>
          </React.Fragment>
        ) : (
          <Box
            width={[1 / 1, '400px']}
            mx="auto"
            px={['20px', 0]}
            style={{ textAlign: 'center' }}
          >
            <p>Have another site to scan?</p>
            <div>
              <Button onClick={e => location.reload()}>Start Over</Button>
            </div>
          </Box>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({
  usFoods,
  user: {
    name,
    email,
    phone,
    zipcode,
    restaurantName,
    usfEmployeeName,
    usfEmployeeEmail,
    usfCustomerId,
    userType
  },
  grade: { is_bentobox: isBentobox },
}) => ({
  usFoods,
  name,
  email,
  phone,
  zipcode,
  restaurantName,
  usfEmployeeName,
  usfEmployeeEmail,
  usfCustomerId,
  userType,
  isBentobox,
  disabled: name.length === 0 || email.length === 0 || restaurantName.length === 0 || !emailIsValid(email),
});

const mapDispatchToProps = dispatch => ({
  submit: async e => {
    ReactGA.event({
      category: 'Results Preview',
      action: 'Click',
      label: 'email-submit',
    });
    dispatch(createLead());
  },
  handleChange: e => dispatch(onInputChange('user', e.target.name, e.target.value))
});

export default connect(mapStateToProps, mapDispatchToProps)(UnlockForm);
